import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import StorefrontIcon from '@mui/icons-material/Storefront';
import ShopService from '../services/ShopService';

const ShopsPage = () => {
  const [shops, setShops] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [savingId, setSavingId] = useState(null);

  const loadShops = async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await ShopService.list();
      setShops(Array.isArray(data) ? data : []);
    } catch (err) {
      setError('Impossible de charger les boutiques');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadShops();
  }, []);

  const handleToggle = async (shop) => {
    const next = !shop.directPurchase;
    setSavingId(shop.id);
    try {
      const updated = await ShopService.updateDirectPurchase(shop.id, next);
      setShops((current) =>
        current.map((item) =>
          item.id === shop.id
            ? { ...item, directPurchase: Boolean(updated.directPurchase) }
            : item
        )
      );
      toast.success(
        next
          ? `Achat direct activé pour ${shop.name}`
          : `Mise en relation rétablie pour ${shop.name}`
      );
    } catch (err) {
      toast.error("Impossible de mettre à jour le mode d'achat");
    } finally {
      setSavingId(null);
    }
  };

  return (
    <div className="animate-in">
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-white mb-2">Boutiques</h1>
        <p className="text-surface-400">
          L&apos;achat direct n&apos;est pas encore disponible. Toutes les boutiques restent en mise
          en relation tant que ce commutateur est désactivé.
        </p>
      </div>

      <div className="card overflow-hidden">
        {loading && <p className="p-6 text-surface-400">Chargement…</p>}
        {error && <p className="p-6 text-red-400">{error}</p>}
        {!loading && !error && shops.length === 0 && (
          <p className="p-6 text-surface-500">Aucune boutique pour l&apos;instant.</p>
        )}
        {!loading && !error && shops.length > 0 && (
          <ul className="divide-y divide-surface-800">
            {shops.map((shop) => (
              <li key={shop.id} className="flex items-center gap-4 px-6 py-4">
                <StorefrontIcon className="w-5 h-5 text-surface-500 flex-shrink-0" />
                <div className="min-w-0 flex-1">
                  <p className="text-sm font-medium text-white truncate">{shop.name}</p>
                  <p className="text-xs text-surface-500 truncate">
                    {shop.creatorName}
                    {shop.slug ? ` · /boutiques/${shop.slug}` : ''}
                  </p>
                </div>
                <label className="flex items-center gap-2 text-sm text-surface-200 cursor-pointer">
                  <input
                    type="checkbox"
                    checked={Boolean(shop.directPurchase)}
                    disabled={savingId === shop.id}
                    onChange={() => handleToggle(shop)}
                    aria-label={`Achat direct pour ${shop.name}`}
                  />
                  Achat direct
                </label>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};

export default ShopsPage;
